import { lazy } from 'react';

const CompleteAccountPage = lazy(() => import('./pages/CompleteAccountPage'));

export const CompleteAccountEntry = () => <CompleteAccountPage />;
